import ls from 'local-storage'
import Storage from "./WEB/Storage"




export default Storage